<template>
  <button type="button" class="btn btn-link" :class="{ copied: recentlyCopiedRef }" @click="onCopy">
    <CheckIcon v-if="recentlyCopiedRef" />
    <CopyIcon v-else />
    {{ buttonTextRef }}
  </button>
</template>

<style lang="scss" scoped>
button.btn-link {
  font-size: 0.875rem;
  color: #888;

  transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out;
  &:hover {
    color: #333;
  }
  &.copied {
    color: #333;
    background-color: #e0ffe0;
  }
}
</style>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { AsyncUtil } from './AsyncUtil'
import { CheckIcon, CopyIcon } from '@zhuowenli/vue-feather-icons'
import { useClipboard } from '@vueuse/core'

const props = defineProps<{
  copyText: string
  text?: string
}>()

const { copy } = useClipboard({ legacy: true })

const originalText = computed(() => props.text ?? 'Copy')
const recentlyCopiedRef = ref(false)
const buttonTextRef = computed(() => recentlyCopiedRef.value ? 'Copied!' : originalText.value)

onMounted(() => {
  recentlyCopiedRef.value = false
})

async function onCopy() {
  if (props.copyText) {
    copy(props.copyText)
    recentlyCopiedRef.value = true
    await AsyncUtil.delay(3000)
    recentlyCopiedRef.value = false
  }
}

</script>
